import React, { useEffect, useMemo, useState } from "react";
import {
  Form,
  Input,
  InputNumber,
  Select,
  Button,
  DatePicker,
  Checkbox,
  Steps,
  Row,
  Col,
  message,
  Modal,
} from "antd";
import MapInput from "./MapInput";
import toast from "react-hot-toast";
import * as S from "./AjouterProjetForm.styles";
import { useDispatch } from "react-redux";
import {
  addProject,
  fetchCommunes,
  fetchPrefectures,
  fetchRegions,
} from "../../store/slices/projectSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import {
  AdresseBody,
  ProjectBody,
  ProjectDetailsModel,
} from "../../domaine/projectModel";
import { addAdresseApi } from "../../api/projects.api";
import moment from "moment";
import dayjs from "dayjs";
import {
  ArrowLeftOutlined,
  CheckOutlined,
  CloudFilled,
  LeftCircleOutlined,
  MinusCircleOutlined,
  PlusOutlined,
  ReloadOutlined,
  RightCircleOutlined,
  RightOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import AddressFieldsList from "./components/AddressFieldsList";
import TranchesLocationMap from "./components/TranchesLocationMap";
import { useNavigate } from "react-router-dom";
import Title from "antd/es/typography/Title";
import { useMediaQuery } from "react-responsive";

const { Step } = Steps;

const AjouterProjetFormV2 = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const dispatch = useDispatch();
  const dateFormat = "DD/MM/YYYY";

  // for responsive
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 575px)" });

  const { regions, prefectures, communes } = useSelector(
    (state: RootState) => state.projects
  );

  const regionsOptions = regions.map((region) => ({
    value: region.id,
    label: region.nom,
  }));

  const initialState: ProjectBody = {
    nom_du_projet: "",
    titre_foncier: null,
    numero_de_permis_de_construire: null,
    type_realisation: null,

    //adresse globale du projet sans coordonnes geographiques
    region: "",
    prefecture_province: "",
    commune: "",

    tranches: [
      // {
      //   name:null,
      //   surface_fonciere: null,
      //   surface_construite: null,
      //   surface_vendable: null,
      //   date_de_permis_de_construire: null,
      //   date_permis_d_habiter: null,
      // }
    ],

    adresses: [],
  };
  const [formData, setFormData] = useState(initialState);
  const [isRegionSelected, setIsRegionSelected] = useState(false);
  const [isPrefectureSelected, setIsPrefectureSelected] = useState(false);
  const prefectureOptions = useMemo(() => {
    if (isRegionSelected) {
      return prefectures.map((prefecture) => ({
        value: prefecture.id,
        label: prefecture.nom,
      }));
    }
    return [];
  }, [prefectures, isRegionSelected]);

  const commmuneOptions = useMemo(() => {
    if (isPrefectureSelected) {
      return communes.map((commune) => ({
        value: commune.id,
        label: commune.nom,
      }));
    }
    return [];
  }, [communes, isPrefectureSelected]);

  const typeRealisationOptions = [
    { value: "En totalité", label: "En totalité" },
    { value: "Par tranches", label: "Par tranches" },
  ];

  const handleRegionSelect = async (regionId: number) => {
    console.log(regionId);
    await dispatch(fetchPrefectures(regionId));

    setIsRegionSelected(true);
    setIsPrefectureSelected(false);
    form.setFieldsValue({ prefecture_province: "" });
    form.setFieldsValue({ commune: "" });
  };

  const handlePrefectureSelect = async (prefectureId: number) => {
    await dispatch(fetchCommunes(prefectureId));
    setIsPrefectureSelected(true);
    form.setFieldsValue({ commune: "" });
  };

  const handleProgrammationChange = (value: string[]) => {
    console.log(value);
  };

  const steps = [
    {
      title: "Informations du projet",
      content: (
        <>
          <Row style={{ width: "100%", padding: "20px" }} justify={"center"}>
            <Col md={12} lg={12} xs={24} sm={24}>
              <Form.Item
                name="nom_du_projet"
                label="Nom du projet"
                rules={[
                  {
                    required: true,
                    message: "Veuillez saisir le nom du projet",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item name="titre_foncier" label="Titre Foncier">
                <Input />
              </Form.Item>
              <Form.Item
                name="numero_de_permis_de_construire"
                label="Numéro de permis de construire"
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="type_realisation"
                label="Type de réalisation"
                rules={[
                  {
                    required: true,
                    message:
                      "Veuillez sélectionner le type de réalisation du projet",
                  },
                ]}
              >
                <Select options={typeRealisationOptions} />
              </Form.Item>
            </Col>
          </Row>
        </>
      ),
    },

    {
      title: "Surfaces et Dates",
      content: (
        <>
          <Row style={{ width: "100%", padding: "20px" }} justify={"center"}>
            <Col md={24} lg={24} xs={24} sm={24}>
              <Form.List name="tranches">
                {(fields, { add, remove }) => {
                  // Handle transition from "Par tranches" to "En totalité"
                  if (
                    formData.type_realisation === "En totalité" &&
                    fields.length > 1
                  ) {
                    for (let i = fields.length - 1; i >= 0; i--) {
                      remove(i);
                    }

                    // Add a new empty field
                    add({
                      name: null,
                      surface_fonciere: null,
                      surface_construite: null,
                      surface_vendable: null,
                      date_de_permis_de_construire: null,
                      date_permis_d_habiter: null,
                      phase_du_projet: null,
                      etat_avancement: null,
                      a_visiter: true,
                      suivi_initial:true
                    });
                    setFormData((prev: any) => ({
                      ...prev,
                      tranches: [
                        {
                          name: null,
                          surface_fonciere: null,
                          surface_construite: null,
                          surface_vendable: null,
                          date_de_permis_de_construire: null,
                          date_permis_d_habiter: null,
                          phase_du_projet: null,
                          etat_avancement: null,
                          a_visiter: true,
                          suivi_initial:true
                        },
                      ],
                    }));
                  }

                  // Ensure at least one tranche exists
                  if (fields.length === 0) {
                    add({
                      name: null,
                      surface_fonciere: null,
                      surface_construite: null,
                      surface_vendable: null,
                      date_de_permis_de_construire: null,
                      date_permis_d_habiter: null,
                      phase_du_projet: null,
                      etat_avancement: null,
                      a_visiter: true,
                      suivi_initial:true
                    });
                  }

                  return (
                    <>
                      {fields.map(({ key, name, ...restField }) => {
                        // Get the current tranche's phase and state directly from form values
                        const currentPhase = form.getFieldValue([
                          "tranches",
                          name,
                          "phase_du_projet",
                        ]);
                        const currentEtat = form.getFieldValue([
                          "tranches",
                          name,
                          "etat_avancement",
                        ]);
                        const isTrancheEnChantier =
                          currentPhase === "en chantier";
                        const requiresSurfaceDetails =
                          isTrancheEnChantier &&
                          ["Gros Oeuvres", "Finition"].includes(currentEtat);
                        return (
                          <div key={key}>
                            {formData.type_realisation === "Par tranches" && (
                              <S.SpanLined>
                                Informations de la tranche {name + 1}
                              </S.SpanLined>
                            )}
                            <Row
                              gutter={16}
                              justify={"space-between"}
                              style={{ width: "100%" }}
                            >
                              <Col md={10} lg={10} xs={24} sm={24}>
                                {formData.type_realisation ===
                                  "Par tranches" && (
                                  <Form.Item
                                    {...restField}
                                    name={[name, "name"]}
                                    label="Nom de la tranche"
                                    rules={[
                                      {
                                        required: true,
                                        message:
                                          "Veuillez saisir le nom de la tranche",
                                      },
                                      ({ getFieldValue }) => ({
                                        validator(_, value) {
                                          if (!value) return Promise.resolve(); // Évite une erreur si le champ est vide

                                          const tranches =
                                            getFieldValue("tranches") || [];
                                          const normalizedValue = value
                                            .trim()
                                            .toLowerCase()
                                            .replace(/\s+/g, ""); // Supprime les espaces et normalise
                                          const duplicate =
                                            tranches.filter(
                                              (t: any) =>
                                                t.name &&
                                                t.name
                                                  .trim()
                                                  .toLowerCase()
                                                  .replace(/\s+/g, "") ===
                                                  normalizedValue
                                            ).length > 1;

                                          if (duplicate) {
                                            return Promise.reject(
                                              new Error(
                                                "Ce nom de tranche est déjà utilisé."
                                              )
                                            );
                                          }

                                          return Promise.resolve();
                                        },
                                      }),
                                    ]}
                                  >
                                    <Input />
                                  </Form.Item>
                                )}

                                <Form.Item
                                  {...restField}
                                  label="Date de permis de construire"
                                  name={[name, "date_de_permis_de_construire"]}
                                  rules={[
                                    ({ getFieldValue }) => ({
                                      validator(_, value) {
                                        const datePermisHabiter = getFieldValue(
                                          [
                                            "tranches",
                                            name,
                                            "date_permis_d_habiter",
                                          ]
                                        );
                                        if (
                                          value &&
                                          datePermisHabiter &&
                                          value.isAfter(datePermisHabiter)
                                        ) {
                                          return Promise.reject(
                                            new Error(
                                              "La date de permis de construire doit être antérieure à la date de permis d'habiter."
                                            )
                                          );
                                        }
                                        return Promise.resolve();
                                      },
                                    }),
                                  ]}
                                >
                                  <DatePicker
                                    format={dateFormat}
                                    style={{ width: "100%" }}
                                  />
                                </Form.Item>

                                <Form.Item
                                  {...restField}
                                  label="Date de permis d'habiter"
                                  name={[name, "date_permis_d_habiter"]}
                                  rules={[
                                    // {
                                    //   required: true,
                                    //   message:
                                    //     "Veuillez saisir la date de permis d'habiter",
                                    // },
                                    ({ getFieldValue }) => ({
                                      validator(_, value) {
                                        const datePermisConstruire =
                                          getFieldValue([
                                            "tranches",
                                            name,
                                            "date_de_permis_de_construire",
                                          ]);
                                        if (
                                          value &&
                                          datePermisConstruire &&
                                          value.isBefore(datePermisConstruire)
                                        ) {
                                          return Promise.reject(
                                            new Error(
                                              "La date de permis d'habiter doit être postérieure à la date de permis de construire."
                                            )
                                          );
                                        }
                                        return Promise.resolve();
                                      },
                                    }),
                                  ]}
                                >
                                  <DatePicker
                                    format={dateFormat}
                                    style={{ width: "100%" }}
                                  />
                                </Form.Item>
                                <Form.Item
                                  {...restField}
                                  label={
                                    formData.type_realisation === "En totalité"
                                      ? "Phase du projet"
                                      : "Phase de la tranche"
                                  }
                                  name={[name, "phase_du_projet"]}
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                        "Veuillez saisir la phase du projet",
                                    },
                                  ]}
                                >
                                  <Select
                                    onChange={() => {
                                      // Force a re-render to update conditional fields
                                      form.validateFields([
                                        ["tranches", name, "etat_avancement"],
                                      ]);
                                    }}
                                  >
                                    <Select.Option value="en chantier">
                                      En chantier
                                    </Select.Option>
                                    <Select.Option value="en livraison">
                                      En livraison
                                    </Select.Option>
                                    <Select.Option value="livré">
                                      Livré
                                    </Select.Option>
                                  </Select>
                                </Form.Item>

                                {/* Only show etat_avancement if this specific tranche is en chantier */}
                                {isTrancheEnChantier && (
                                  <Form.Item
                                    {...restField}
                                    label="Etat d'avancement des travaux de construction"
                                    name={[name, "etat_avancement"]}
                                    rules={[{ required: isTrancheEnChantier }]}
                                  >
                                    <Select
                                      onChange={() => {
                                        // Force a re-render to update requirement for surface fields
                                        form.validateFields([
                                          [
                                            "tranches",
                                            name,
                                            "surface_construite",
                                          ],
                                          [
                                            "tranches",
                                            name,
                                            "surface_vendable",
                                          ],
                                        ]);
                                      }}
                                    >
                                      <Select.Option value="Inconnu">
                                        Inconnu
                                      </Select.Option>
                                      <Select.Option value="Phase étude">
                                        Phase étude
                                      </Select.Option>
                                      <Select.Option value="Terrasement">
                                        Terrasement
                                      </Select.Option>
                                      <Select.Option value="Viabilisation">
                                        Viabilisation
                                      </Select.Option>
                                      <Select.Option value="Gros Oeuvres">
                                        Gros Oeuvres
                                      </Select.Option>
                                      <Select.Option value="Finition">
                                        Finition
                                      </Select.Option>
                                    </Select>
                                  </Form.Item>
                                )}
                              </Col>
                              <Col md={10} lg={10} xs={24} sm={24}>
                                <Form.Item
                                  {...restField}
                                  name={[name, "surface_fonciere"]}
                                  label="Surface foncière"
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                        "Veuillez saisir la surface foncière",
                                    },
                                  ]}
                                >
                                  <InputNumber
                                    min={0}
                                    addonAfter="m²"
                                    style={{ width: "100%" }}
                                  />
                                </Form.Item>
                                <Form.Item
                                  {...restField}
                                  label="Surface construite"
                                  name={[name, "surface_construite"]}
                                  rules={[
                                    {
                                      required:
                                      isTrancheEnChantier && ["Gros Oeuvres", "Finition"].includes(currentEtat) ||
                                      currentPhase === "livré" || 
                                      currentPhase === "en livraison",
                                      message:
                                        "Veuillez saisir la surface construite",
                                    },
                                  ]}
                                >
                                  <InputNumber
                                    min={0}
                                    addonAfter="m²"
                                    style={{ width: "100%" }}
                                    onChange={(value) => {
                                      // Calculate 75% of surface_construite and set it to surface_vendable
                                      if (value) {
                                        const surfaceVendable = Number(
                                          value * 0.75
                                        ).toFixed(2);
                                        form.setFieldsValue({
                                          tranches: {
                                            [name]: {
                                              surface_vendable: surfaceVendable,
                                            },
                                          },
                                        });
                                      }
                                    }}
                                  />
                                </Form.Item>
                                <Form.Item
                                  {...restField}
                                  label="Surface vendable"
                                  name={[name, "surface_vendable"]}
                                  rules={[
                                    {
                                      required:
                                      isTrancheEnChantier && ["Gros Oeuvres", "Finition"].includes(currentEtat) ||
                                      currentPhase === "livré" || 
                                      currentPhase === "en livraison",
                                      message:
                                        "Veuillez saisir la surface vendable",
                                    },
                                  ]}
                                  hasFeedback
                                  validateStatus={
                                    form.getFieldValue([
                                      "tranches",
                                      name,
                                      "surface_vendable",
                                    ]) &&
                                    form.getFieldValue([
                                      "tranches",
                                      name,
                                      "surface_construite",
                                    ]) &&
                                    form.getFieldValue([
                                      "tranches",
                                      name,
                                      "surface_vendable",
                                    ]) <
                                      0.75 *
                                        form.getFieldValue([
                                          "tranches",
                                          name,
                                          "surface_construite",
                                        ])
                                      ? "warning"
                                      : ""
                                  }
                                  help={
                                    form.getFieldValue([
                                      "tranches",
                                      name,
                                      "surface_vendable",
                                    ]) &&
                                    form.getFieldValue([
                                      "tranches",
                                      name,
                                      "surface_construite",
                                    ]) &&
                                    form.getFieldValue([
                                      "tranches",
                                      name,
                                      "surface_vendable",
                                    ]) <
                                      0.75 *
                                        form.getFieldValue([
                                          "tranches",
                                          name,
                                          "surface_construite",
                                        ])
                                      ? "La surface vendable est inférieure à 75% de la surface construite."
                                      : ""
                                  }
                                >
                                  <InputNumber
                                    min={0}
                                    addonAfter="m²"
                                    style={{ width: "100%" }}
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                            <Row
                              gutter={16}
                              justify={"end"}
                              style={{ width: "100%", marginBottom: "10px" }}
                            >
                              {formData.type_realisation === "Par tranches" && (
                                <Button
                                  variant="solid"
                                  color="danger"
                                  disabled={fields.length === 1 ? true : false}
                                  onClick={() => {
                                    remove(name);
                                  }}
                                  icon={<MinusCircleOutlined />}
                                ></Button>
                              )}
                            </Row>
                          </div>
                        );
                      })}
                      {formData.type_realisation === "Par tranches" && (
                        <Form.Item>
                          <Button
                            variant="solid"
                            color="primary"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                          >
                            Ajouter une tranche
                          </Button>
                        </Form.Item>
                      )}
                    </>
                  );
                }}
              </Form.List>
            </Col>
          </Row>
        </>
      ),
    },
    {
      title: "Cordonnées et adresse",
      content: (
        <>
          <Row
            style={{ width: "100%", padding: "20px" }}
            justify={"center"}
            gutter={16}
          >
            <Col md={8} lg={8} xs={24} sm={24}>
              <Form.Item
                name="region"
                label="Region"
                rules={[
                  { required: true, message: "Veuillez saisir la région" },
                ]}
              >
                <Select
                  onChange={handleRegionSelect}
                  options={regionsOptions}
                  placeholder="Selectionnez une région"
                ></Select>
              </Form.Item>
            </Col>
            <Col md={8} lg={8} xs={24} sm={24}>
              <Form.Item
                name="prefecture_province"
                label="Prefecture/Province"
                rules={[
                  {
                    required: true,
                    message: "Veuillez saisir la préfecture/province",
                  },
                ]}
              >
                <Select
                  disabled={!isRegionSelected ? true : false}
                  options={prefectureOptions}
                  onChange={handlePrefectureSelect}
                ></Select>
              </Form.Item>
            </Col>
            <Col md={8} lg={8} xs={24} sm={24}>
              <Form.Item
                name="commune"
                label="Commune"
                rules={[
                  { required: true, message: "Veuillez saisir la commune" },
                ]}
              >
                <Select
                  disabled={!isPrefectureSelected ? true : false}
                  options={commmuneOptions}
                ></Select>
              </Form.Item>
            </Col>
          </Row>

          <Row
            style={{ width: "100%", padding: "20px" }}
            justify={"center"}
            gutter={16}
          >
            <TranchesLocationMap
              selectedCommune={form.getFieldValue("commune")}
              formData={formData}
              setFormData={setFormData}
              tranches={formData.tranches}
            />
          </Row>
        </>
      ),
    },
  ];

  const handleValuesChange = (changedValues: any, allValues: any) => {
    setFormData((prev) => ({ ...prev, ...allValues }));

    if (changedValues.type_realisation === "En totalité") {
      setFormData((prev) => ({
        ...prev,
        tranches: [
          {
            name: null,
            surface_fonciere: null,
            surface_construite: null,
            surface_vendable: null,
            date_de_permis_de_construire: null,
            date_permis_d_habiter: null,
            phase_du_projet: null,
            etat_avancement: null,
            a_visiter: true,
            suivi_initial: true,
            
          },
        ],
      }));
    }

    if (
      changedValues.type_realisation === "Par tranches" &&
      formData.tranches.length === 1
    ) {
      formData.tranches[0].name = null;
      // set fieldvalue of tranche[0].name to null
      form.setFieldValue("tranches[0].name", null);
    }
  };

  const next = async () => {
    try {
      const currentFields = await form.validateFields();

      setFormData({
        ...formData,
        ...currentFields,
      });

      console.log("Données form :", formData);
      setCurrent(current + 1);
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const onFinish = async () => {
    try {
      const currentFields = await form.validateFields();
      const finalFormData = { ...formData, ...currentFields };

      // Process the date fields
      const dateFormat = "DD/MM/YYYY";
      const dateFields = [
        "date_de_permis_de_construire",
        "date_permis_d_habiter",
      ];
      if (finalFormData.tranches && Array.isArray(finalFormData.tranches)) {
        finalFormData.tranches = finalFormData.tranches.map((tranche: any) => {
          const updatedTranche = { ...tranche };
          // Set a_visiter to false if phase_du_projet is "livré"
          if (updatedTranche.phase_du_projet === "livré") {
            updatedTranche.a_visiter = false;
            updatedTranche.suivi_initial = false;
          } 
          dateFields.forEach((field) => {
            if (updatedTranche[field]) {
              updatedTranche[field] = dayjs(updatedTranche[field]).format(
                dateFormat
              );
            }
          });
          return updatedTranche;
        });
      }

      const { adresses, region, prefecture, commune, ...filteredFormData } =
        finalFormData;

      // 2. Validate matching tranches and addresses
      if (filteredFormData.tranches?.length !== adresses.length) {
        toast.error("Veuillez dessiner la totalité du projet.");
        return;
      }

      // 1. Add all addresses and collect their IDs
      const addressIds = await Promise.all(
        adresses.map(async (addr: any) => {
          const adressBody = {
            adresse: addr.adresse,
            fk_commune: commune, // Ensure commune has an ID
            coordonnees_longitude: addr.longitude,
            coordonnees_latitude: addr.latitude,
            coordonnees_polygone: addr.coordinates,
          };
          return await addAdresseApi(adressBody, "addresses/");
        })
      );

      // 2. Validate matching tranches and addresses
      if (filteredFormData.tranches?.length !== addressIds.length) {
        throw new Error("Number of tranches must match number of addresses");
      }

      // 3. Assign address IDs to tranches
      filteredFormData.tranches = filteredFormData.tranches.map(
        (tranche: any, index: number) => ({
          ...tranche,
          fk_adresse: addressIds[index], // Assign corresponding address ID
        })
      );

      // 4. Create project payload
      const projectBody = {
        ...filteredFormData,
        // Include other project fields as needed
      };

      if (filteredFormData.type_realisation === "En totalité") {
        projectBody.tranches[0].name = `Tranche principale - ${projectBody.nom_du_projet}`;
      }

      // 5. Submit project
      await dispatch(addProject(projectBody))
        .unwrap()
        .then(() => {
          form.resetFields();
          setIsPrefectureSelected(false);
          setIsRegionSelected(false);
          toast.success("Projet enregistré avec succès");
        })
        .catch((error: any) => {
          console.error("Error adding project:", error);
          toast.error("Une erreur est survenue");
        });

      // Reset form state
      setFormData(initialState);
      setCurrent(0);
      navigate("/projectsList");
    } catch (error) {
      console.error("Form submission failed:", error);
      toast.error("Échec de la soumission du formulaire");
    }
  };

  const reset = () => {
    form.resetFields();
    setFormData(initialState);
    setCurrent(0);
    setIsPrefectureSelected(false);
    setIsRegionSelected(false);
  };

  useEffect(() => {
    dispatch(fetchRegions());
  }, []);

  return (
    <S.StepWrapper>
      <div
        style={{
          display: "flex",
          justifyContent: "start",
          paddingLeft: "10px",
          paddingBottom: "20px",
        }}
      >
        <Button
          variant="outlined"
          color="primary"
          onClick={() => navigate("/projectsList")}
          icon={<ArrowLeftOutlined />}
        >
          Retour
        </Button>
      </div>
      <Title level={4} style={{ width: "100%", padding: "10px" }}>
        Création du projet
      </Title>
      <Steps
        progressDot
        size="small"
        direction="horizontal"
        current={current}
        style={{ padding: "0 10px", marginBottom: "20px", width: "100%" }}
      >
        {steps.map((item) => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={initialState}
        onValuesChange={handleValuesChange}
        style={{
          padding: "0 10px",
          paddingBottom: "10px",
          flex: 1,
          width: "100%",
        }}
      >
        <div style={{ marginBottom: "20px", width: "100%" }}>
          {steps[current].content}
        </div>
        <Row style={{ width: "100%" }} justify={"center"}>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={12}
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 20px",
            }}
          >
            <div>
              <Button
                onClick={reset}
                style={{ marginRight: "20px" }}
                icon={<ReloadOutlined />}
              ></Button>
              {/*<Button
                icon={<SaveOutlined />}
                color="default"
                variant="filled"
              ></Button>*/}
            </div>

            <div>
              {current > 0 && (
                <Button
                  icon={<LeftCircleOutlined />}
                  onClick={prev}
                  style={{ marginRight: "20px" }}
                >
                  {isTabletOrMobile ? "" : "Précédent"}
                </Button>
              )}
              {current < steps.length - 1 && (
                <Button
                  icon={<RightCircleOutlined />}
                  iconPosition="end"
                  type="primary"
                  onClick={next}
                >
                  {isTabletOrMobile ? "" : "Suivant"}
                </Button>
              )}
              {current === steps.length - 1 && (
                <Button
                  icon={<CheckOutlined />}
                  type="primary"
                  htmlType="submit"
                >
                  Confirmer
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </Form>
    </S.StepWrapper>
  );
};

export default AjouterProjetFormV2;
